import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, CommentLayout, UserDefinedLayout } from './Layout';
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel as GridLoadPanel,
    Lookup,
    Item,
    Toolbar,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
    StateStoring
} from "devextreme-react/data-grid";
import DataSource from 'devextreme/data/data_source';
import { createStore } from 'devextreme-aspnet-data-nojquery';
function POTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
var accessToken = props.oidc.user.access_token;

    const poHeaderDataSource = new DataSource({
        store: new createStore({
            key: 'Rowid',
            loadParams: {
                transactionId: function () {
                    return props.formFields.Rowid??'00000000-0000-0000-0000-000000000000';
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetPoOrders`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
    });
        const poReceiptDataSource = new DataSource({
        store: new createStore({
            key: 'Rowid',
            loadParams: {
                transactionId: function () {
                    return props.formFields.Rowid??'00000000-0000-0000-0000-000000000000';
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetPoOrdersReceipt`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
    });
    return (
       <div  style={{marginTop:'12px'}}>
        <div className="row">
            <div className="col-md-6">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={poHeaderDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    remoteOperations={true}
                    hoverStateEnabled={true}
                    height="100%"
                >
                    <Selection mode="single" />
                    <ColumnHeaderFilter />
                    <Sorting visible={true} mode="multiple" />
                    <GridLoadPanel enabled={true} />
                    <FilterRow visible={true} />
                    <Grouping autoExpandAll={false} />
                    <Column dataField="VendorID" caption="Vendor" dataType="string" />
                    <Column dataField="PONumber" caption="PO#" dataType="string" />
                    <Column dataField="PODate" caption="PO Date" dataType="datetime" />
                    <Column dataField="DateRequired" caption="Date Required" dataType="datetime" />
                    <Column dataField="DateExpected" caption="Date Expected" dataType="datetime" />
                    <Column dataField="ApprovalDate" caption="Approval Date" dataType="datetime" />
                    <Column dataField="ApproverID" caption="Approved by" dataType="string" />
                    <Column dataField="Description" caption="Expiration Date" dataType="string" />
                    <Column dataField="Availablereasoncode" caption="PO Description" dataType="string" />
                </DataGrid>
            </div>
            <div className="col-md-6">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={poReceiptDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    remoteOperations={true}
                    hoverStateEnabled={true}
                    height="100%"
                >
                    <Selection mode="single" />
                    <ColumnHeaderFilter />
                    <Sorting visible={true} mode="multiple" />
                    <GridLoadPanel enabled={true} />
                    <FilterRow visible={true} />
                    <Grouping autoExpandAll={false} />
                    <Column dataField="PONumber" caption="PO#" dataType="string" />
                    <Column dataField="Status" caption="Status" dataType="string" />
                    <Column dataField="VendorID" caption="Vendor" dataType="string" />
                    <Column dataField="ReferenceNumber" caption="Reference#" dataType="string" />
                    <Column dataField="InvoiceNumber" caption="Invoice#" dataType="string" />
                    <Column dataField="InvoiceDate" caption="Invoice Date" dataType="datetime" />
                    <Column dataField="DateReceived" caption="Received Date" dataType="datetime" />
                </DataGrid>
            </div>
        </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(POTab);
